import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';

@Injectable()
export class ChairsProxy {
    constructor(
        private http: HttpClient,
        private configurationService: ConfigurationService,
    ) {}

    async createChair(practiceId: string, chair: CreateOrUpdateChairDTO): Promise<void> {
        const url = this.configurationService.APIURL + '/api/chairs';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        return await this.http.post<void>(url, chair, { params }).toPromise();
    }

    async updateChair(practiceId: string, id: string, chair: CreateOrUpdateChairDTO): Promise<void> {
        const url = this.configurationService.APIURL + '/api/chairs/' + id;
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        return await this.http.put<void>(url, chair, { params }).toPromise();
    }

    async deleteChair(practiceId: string, chairId: string): Promise<void> {
        const url = this.configurationService.APIURL + '/api/chairs/' + chairId;
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        return await this.http.delete<void>(url, { params }).toPromise();
    }

    async getChairs(groupId: string, practiceId: string): Promise<ChairSummaryDTO[]> {
        const url = this.configurationService.APIURL + '/api/chairs';
        let params = new HttpParams();
        if (groupId) {
            params = params.append('groupId', String(groupId));
        }
        params = params.append('practiceId', String(practiceId));
        return await this.http.get<ChairSummaryDTO[]>(url, { params }).toPromise();
    }
}

export enum WaterSupplies {
    Bottled = 0,
    WaterLineWithBackflowPrevention = 1,
    WaterLineWithoutBackflowPrevention = 2,
}

export enum UsageFrequencies {
    LessThanOneDayAWeek = 0,
    OneTwoDaysAWeek = 1,
    ThreeFourDaysAWeek = 2,
    FiveSixDaysAWeek = 3,
    SevenDaysAWeek = 4,
}

export enum ChairOrderStatus {
    PendingRetest = 2,
    TestRequired = 3,
    KitSentToPractice = 5,
    InLab = 20,
    LabProcessing = 25,
    ResultComplete = 28,
    ResultOut = 30,
}

export interface CreateOrUpdateChairDTO {
    practiceId: string;
    id?: string;
    name: string;
    brand: string;
    inUseSinceYear: number;
    waterSupply: WaterSupplies;
    usageFrequency: UsageFrequencies;
    note: string;
}

export interface ChairSummaryDTO {
    id: string;
    practiceId: string;
    practiceName: string;
    createdBy: string;
    createdOn: null | string | Date;
    name: string;
    waterSupply: WaterSupplies;
    brand: string;
    note: string;
    inUseSinceYear: number;
    usageFrequency: UsageFrequencies;

    nextTestDate: null | string | Date;
    canRequestTest: boolean;
    pendingRetestOrderId: string | null;

    lastOrder: ChairOrderDTO | null;
    resultOutOrders: ChairOrderDTO[];

    // clientSide
    isAddingMode: boolean;
}

export interface ChairOrderDTO {
    id: string;
    status: ChairOrderStatus;
    labNumber: string;
    createdOn: Date | string;
    toBeExecutedOn: Date | string;
    inLabReceivedOn: Date | string | null;
    resultOutOn: Date | string | null;
    result: number;
    isGreen: boolean;
    isYellow: boolean;
    isOrange: boolean;
    isRed: boolean;
    actionItems: ActionItemSummaryDTO[];
}

export interface ActionItemSummaryDTO {
    id: string;
    chairOrderId: string;
    text: string;
    isChecked: boolean;
}
